import { NavLink } from 'react-router-dom';
import { localiseDigits } from '@bookingdei/i18n/format-number';
import { useLanguage } from './language-context';
import { NavIcon } from './nav-icon';
import { visibleNavItems } from './nav-items';

// The floating mobile bar below 900 px (design M:3894-3920; DR-45): exactly four
// slots — Home · Bookings · Services · More. More opens the More sheet (every other
// page, incl. Inbox and QR studio). The Bookings slot carries the pending-proofs
// badge. CB-17 `tab-bar.tsx`. A team member's session (API-16) keeps only the page
// slots it may open (Home · Bookings) and More.
export function TabBar({
  pending,
  isStaff,
  moreOpen,
  onMore,
}: {
  pending: number;
  isStaff: boolean;
  moreOpen: boolean;
  onMore: () => void;
}) {
  const { lang, t } = useLanguage();
  const slots = visibleNavItems(isStaff).filter((i) => i.slot);
  return (
    <nav className="tab-bar" aria-label={t('merchant.nav.primary')}>
      {slots.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) => `tab-bar__link${isActive && !moreOpen ? ' is-active' : ''}`}
          data-nav={item.to}
        >
          <span className="tab-bar__icon">
            <NavIcon name={item.icon} size={19} strokeWidth={2} />
            {item.badge === 'pending_proofs' && pending > 0 && (
              <span className="tab-bar__badge">{localiseDigits(lang, pending)}</span>
            )}
          </span>
          <span>{t(item.key)}</span>
        </NavLink>
      ))}
      <button
        type="button"
        className={`tab-bar__link${moreOpen ? ' is-active' : ''}`}
        aria-haspopup="dialog"
        aria-expanded={moreOpen}
        onClick={onMore}
        data-shell="more"
      >
        <span className="tab-bar__icon">
          <NavIcon name="more" size={19} strokeWidth={2.4} />
        </span>
        <span>{t('dc70.nav.more')}</span>
      </button>
    </nav>
  );
}
